import { DiscountType, SaleType, } from "@wix/ambassador-devcenter-managedapps-v1-managed-app/types";
import { DATE_LOCALE } from "../utils/language-to-locales";
export const getIsInSale = (app) => Boolean(app?.pricingDetails?.discount);
export const getDiscountAmount = (app) => app?.pricingDetails?.discount?.amount;
export const getSaleType = (app) => app?.pricingDetails?.discount?.saleInfo?.saleType;
export const getIsDiscountTypeIsPercentage = (app) => app?.pricingDetails?.discount?.type === DiscountType.PERCENTAGE;
export const getIsDevSale = (app) => app?.pricingDetails?.discount?.saleInfo?.saleType === SaleType.DEVELOPER_SALE;
export const getEndDate = (app, languageCode) => {
    const dateResponse = app?.pricingDetails?.discount?.saleInfo?.endDate;
    const stringDate = dateResponse.toString();
    const newDate = new Date(stringDate).toLocaleDateString(DATE_LOCALE[languageCode], {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
    });
    return newDate;
};
//# sourceMappingURL=managedApp.js.map